// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__wYpHQ","mobileOpen":"Logo_mobile-open__l2LUA","showOnTable":"Logo_show-on-table__uKHA0"};